import { useLanguage } from "@/contexts/LanguageContext";
import { PageContainer } from "@/components/flowly/PageContainer/PageContainer";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/utils";
import { TestimonialCard } from "./TestimonialCard";
import { TESTIMONIALS } from "./constants";

export function Testimonials() {
  const { t } = useLanguage();
  const { ref: sectionRef, isInView } = useInView();

  return (
    <section className="py-20 md:py-28 bg-muted/50">
      <PageContainer width="wide">
        <div
          ref={sectionRef}
          className={cn(
            "transition-all duration-700",
            isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
          )}
        >
          {/* Header */}
          <div className="text-center mb-12">
            <span className="block text-xs font-semibold tracking-[0.2em] uppercase text-brand mb-3">
              {t.landing.eyebrowTestimonials}
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              {t.landing.testimonialsTitle}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t.landing.testimonialsSubtitle}
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TESTIMONIALS.map((testimonial) => (
              <TestimonialCard
                key={testimonial.nameKey}
                quote={
                  t.landing[
                    testimonial.quoteKey as keyof typeof t.landing
                  ]
                }
                name={
                  t.landing[
                    testimonial.nameKey as keyof typeof t.landing
                  ]
                }
                role={
                  t.landing[
                    testimonial.roleKey as keyof typeof t.landing
                  ]
                }
              />
            ))}
          </div>
        </div>
      </PageContainer>
    </section>
  );
}
